import type { FaireProductEntity } from "../../entity_types/product";

export const p_5gwww9t6r8: FaireProductEntity = {
  token: "p_5gwww9t6r8",
  type: "product",
  name: "FULL LENGTH LINEN SLIP DRESS (23.2237/224008/244008-MOCHA)",
  brandToken: "b_q83zsr8m4m",
  brandName: "MILIO MILANO",
  imageUrl:
    "https://cdn.faire.com/fastly/2cdecc8f5e4801ae5d7fd85be899371f373299e10b0e32687145582471f31e3a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb67f202d001c0fa41bc9ccfd896d6822da25b49ba4e49e7a4853739009e1028.jpeg",
    "https://cdn.faire.com/fastly/70dd142218e93aaa06156983a6aa75ada5b1a239acd1ca78c49e445909f0d231.jpeg",
  ],
  priceDollars: 276,
  description:
    "Linen spaghetti strap V-neck full-length slip dress\n\nConstructed with 100% linen, this dress features a flattering V-neckline, adjustable spaghetti straps, and full-length silhouette. Its airy fit will help you feel cool, refreshed, and stylish all day long. Perfect for any special occasion or outing.",
  tags: [],
  msrpDollars: 690,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:55.086Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
